import Pillar from '../implementations/TaxonomyTerm/Pillar';
import Theme from '../implementations/TaxonomyTerm/Theme';

const mappers = {
  pillar: Pillar,
  theme: Theme,
};

export default mappers;
